import useGlobalConfig from '@/store/global';

const Fibryga = () => {
  const { themeColor } = useGlobalConfig();
  return (
    <>
      <div className="bg-[#f3f3f3] p-4 md:p-8 pt-4 rounded-md">
        <div className="my-6 border-b-2 border-dotted" style={{ borderColor: themeColor }} />

        <div className="font-bold text-base" style={{ color: themeColor }}>
          Indications and Important Safety Information for Fibryga, Fibrinogen (Human)
        </div>

        <p className="mt-2 font-bold">
          Please see fibryga&nbsp;
          <a
            target="_blank"
            href="/fibryga-full-prescribing-information.pdf"
            className="underline"
            rel="noopener noreferrer"
          >
            full Prescribing Information
          </a>
          .
        </p>

        <div className="mt-8">
          <p className="my-2 font-bold">Indications and Usage</p>
          <p className="my-2">
            Fibryga is a human fibrinogen concentrate indicated for fibrinogen supplementation in
            bleeding patients with acquired fibrinogen deficiency and in treatment of acute bleeding
            episodes in patients with congenital fibrinogen deficiency, including afibrinogenemia
            and hypofibrinogenemia.
          </p>
          <p className="my-2">Fibryga is not indicated for dysfibrinogenemia.</p>
        </div>

        <div className="mt-6">
          <p className="my-2 font-bold">Contraindications</p>
          <p className="my-2">
            Fibryga is contraindicated in individuals who have manifested severe immediate
            hypersensitivity reactions, including anaphylaxis, to fibryga or its components (Sodium
            Citrate Dihydrate; Glycine; L-Arginine Hydrochloride).
          </p>
        </div>

        <div className="mt-6">
          <p className="my-2 font-bold">Warnings and Precautions</p>
          <ul>
            <li className="my-2">
              Monitor patients for early signs of hypersensitivity or allergic reactions. If
              necessary, discontinue administration and institute appropriate treatment.
            </li>
            <li className="my-2">
              Thrombotic events have been reported in patients receiving fibryga. Treatment with
              human fibrinogen concentrate has been associated with thrombosis at target plasma
              fibrinogen levels that were below 150 mg/dL. The thrombotic risks may be greater when
              the target fibrinogen plasma level is 150 mg/dL. Weigh the benefits of administration
              versus the risks of thrombosis.
            </li>
            <li className="my-2">
              Fibryga is made from pooled human plasma. Products made from human plasma may contain
              infectious agents, e.g., viruses and, theoretically, the Creutzfeldt-Jakob disease
              (CJD) agent.
            </li>
          </ul>
        </div>

        <div className="mt-6">
          <p className="my-2 font-bold">Adverse Reactions</p>
          <p className="my-2">
            The most serious adverse reactions observed with fibryga are thromboembolic episodes and
            anaphylactic-type reactions.
          </p>
          <p className="my-2">
            The most common adverse reactions observed in clinical studies with fibryga in acquired
            fibrinogen deficiency (&gt;5% of patients) were abnormal hepatic function, acute kidney
            injury, anemia, atrial fibrillation, delirium and renal failure.
          </p>
          <p className="my-2">
            The most common adverse reactions observed in clinical studies with fibryga in
            congenital fibrinogen deficiency (&gt;5% of patients) were nausea, vomiting, pyrexia
            (fever) and thrombocytosis.
          </p>
        </div>

        <div>
          <p className="my-2">
            Please see fibryga&nbsp;
            <a
              target="_blank"
              href="/fibryga-full-prescribing-information.pdf"
              className="underline"
              rel="noopener noreferrer"
            >
              full Prescribing Information
            </a>
            .
          </p>
          <p className="my-2">
            To report suspected adverse reactions, contact Octapharma USA, Inc. at 866-766-4860 or
            the FDA at 800-FDA-1088 or&nbsp;
            <a
              href="http://www.fda.gov/medwatch"
              target="_blank"
              className="underline"
              rel="noopener noreferrer"
            >
              www.fda.gov/medwatch
            </a>
            .
          </p>
        </div>
      </div>
    </>
  );
};

export default Fibryga;
